export default {
  title: 'Nueva autorización',
  selectPreAuthorizationMessage: 'Seleccione un tipo de preautorización para comenzar',
  successLabel: 'La autorización fue creada exitosamente.',
  errorLabel: 'Ocurrió un error en la creación de la autorización.',
  buttons: {
    next: 'Continuar',
    end: 'Finalizar',
    cancel: 'Cancelar',
    return: 'Regresar',
    addFile: 'Agregar',
    exit: 'Salir'
  },
  fields: {
    optional: 'Opcional',
    currency: 'Moneda',
    type: 'Tipo de autorización',
    description: 'Seleccione un tipo de autorización para continuar:',
    wellnessCoverageTypeLabel: 'MÉDICAS',
    othersCoverageTypeLabel: 'OTRAS',
    file: {
      empty: 'No hay archivos adjuntos',
      preview: 'Vista previa'
    },
    claimType: {
      label: 'Solicitud para',
      owner: 'Titular',
      beneficiary: 'Beneficiario'
    },
    formats: 'Archivos en formato {formats} de hasta {size}'
  },
  loadingMessage: 'Creando autorización...',
  diagnoses: {
    panelTitle: 'Diagnósticos',
    title: 'Diagnósticos',
    emptyDiagnoses: 'Aún no se han agregado diagnósticos',
    customDiagnosisItemListLabel: 'Diagnóstico',
    searchLabel: 'Buscar diagnóstico',
    emptyList: 'No se encontraron resultados',
    addDiagnosisLabel: '+ Agregar "{value}"',
    maximumNumberOfItemsReached: 'Cantidad máxima alcanzada',
    errors: {
      repeated: 'Ya ha agregado este diagnóstico'
    }
  },
}
